export const EventType = {
    MUSIC: 'music',
    FILM: 'film',
    CONF: 'conf',
};
